import s from './ContactUsModalWindowContent.module.scss';
import {Form} from "@/app/[locale]/common/components/Form/Form";
import {useResponsive} from "@/app/[locale]/common/utils/hooks/useResponsive/useResponsive";
import {useTranslations} from "next-intl";

export const ContactUsModalWindowContent = () => {
    const t = useTranslations('ContactUsModalWindow');
    const version = useResponsive('desktop', 'mobile', 600) as 'desktop' | 'mobile';
    const formButtonSize = version === 'desktop' ? 'large' : 'mobile';

    return (
        <div className={s.cotactUs}>
            <label className={s.contactUs_label}>{t('title')}</label>
            <Form
                version={version}
                buttonSize={formButtonSize}
                buttonPosition={'center'}
                className={s.contact_form_body}
            />
        </div>
    );
};